import { Box, Typography } from "@mui/material";
import { Trash2 } from "lucide-react";
import { Controller, useFieldArray, UseFormReturn } from "react-hook-form";
import { Button, IconButton, TextField } from "../../../ui";
import Input from "../../input/input";
import InputData from "../../input-data/inputData";
import InputDescricao from "../../input-descricao/inputDescricao";
import { getStatusLabel } from "../../../../../pages/obra/contracts/criar-obra.contract";

interface EnderecoFormProps {
  methods: UseFormReturn<any>;
  disabled?: boolean;
  mdDown?: any;
  showPercentageAndStatus?: boolean; // novo parâmetro para edição
}

export function EtapasDaObraFormPart({
  methods,
  mdDown,
  disabled = false,
  showPercentageAndStatus = false,
}: EnderecoFormProps) {
  const {
    control,
    formState: { errors },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "workStages",
  });

  return (
    <Box>
      <Box display={"block"} mb={1}>
        <Typography variant="h5" padding="20px 0">
          Etapas da Obra
        </Typography>
      </Box>
      {fields.map((stage, idx) => (
        <Box
          key={stage.id}
          mb={2}
          p={2}
          border="1px solid #eee"
          borderRadius={2}
        >
          <Box
            display="grid"
            gridTemplateColumns={mdDown ? "1fr" : "1fr 140px 44px"}
            gap={2}
            alignItems="start"
          >
            <Input
              name={`workStages.${idx}.name`}
              label="Nome da etapa"
              methods={methods}
              disabled={disabled}
            />
            <Input
              name={`workStages.${idx}.order`}
              label="Ordem"
              methods={methods}
              type="number"
              disabled={disabled}
            />
            <IconButton
              title="Remover etapa"
              onClick={() => remove(idx)}
              className="mt-1 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30"
              disabled={disabled}
            >
              <Trash2 className="h-4 w-4" />
            </IconButton>
          </Box>
          <Box display="flex" gap={2} mt={2}>
            <InputData
              name={`workStages.${idx}.startDate`}
              label="Data de início"
              methods={methods}
              disabled={disabled}
            />
            <InputData
              name={`workStages.${idx}.endDate`}
              label="Data de término"
              methods={methods}
              disabled={disabled}
            />
          </Box>
          <Box mt={2}>
            <InputDescricao
              name={`workStages.${idx}.description`}
              label="Descrição da etapa"
              methods={methods}
              disabled={disabled}
              minHeight={80}
            />
          </Box>
          {showPercentageAndStatus && (
            <Box display="flex" gap={2} mt={2}>
              <Input
                name={`workStages.${idx}.percentage`}
                label="Percentual (%)"
                methods={methods}
                type="number"
              />
              <Controller
                name={`workStages.${idx}.status`}
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Status"
                    value={getStatusLabel(field.value)}
                    disabled
                  />
                )}
              />
            </Box>
          )}
        </Box>
      ))}
      {typeof errors.workStages === "string" && (
        <span style={{ color: "#ef4444" }}>{errors.workStages}</span>
      )}
      <Button
        type="button"
        onClick={() =>
          append({
            name: "",
            description: "",
            startDate: new Date(),
            endDate: new Date(),
            order: fields.length + 1,
            percentage: 0,
            status: "",
          })
        }
        className="mt-4"
        disabled={disabled}
      >
        Adicionar etapa
      </Button>
    </Box>
  );
}
